import { Workbook } from "exceljs";
import { LocationData } from "helpers/models";

export const excelSheetLocation = (
  workbook: Workbook,
  location: LocationData,
) => {
  const worksheet1 = workbook.getWorksheet(1);
  if (!worksheet1) {
    return;
  }

  const cellB2 = worksheet1.getCell("B2");
  cellB2.value = location?.name;

  const cellB3 = worksheet1.getCell("B3");
  cellB3.value = location?.currency;

  const cellB4 = worksheet1.getCell("B4");
  cellB4.value = location?.comment;

  const cellB5 = worksheet1.getCell("B5");
  cellB5.value = new Date().toLocaleDateString();
};
